import { h, Component } from "preact";
import "./css/app.css";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import NavBar from "./components/NavBar";
import MainServices from "./components/MainServices";
import WhatWeOffer from "./components/WhatWeOffer";
import Welcome from "./components/Welcome";
import Video from "./components/Video";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ProjectsModal from "./components/ProjectsModal";

// loads the Icon plugin
UIkit.use(Icons);
// components can be called from the imported UIkit reference
//UIkit.notification("Hello world.");
import { IntlProvider } from "preact-i18n";
import PT from "./lang/pt.json";
import ES from "./lang/es.json";
import SV from "./lang/sv.json";
import EN from "./lang/en.json";

/*function getCountry() {
  //if (window.location.href.indexOf("elsalvador") !== -1) {
    //return "elsalvador";
  //}
  if (window.location.href.indexOf("SP") !== -1) {
    return "espanha";
  }
  if (window.location.href.indexOf("EN") !== -1) {
    return "english";
  }
  //return "portugal";
  return "portugal";
}*/

class App extends Component {
  constructor(props) {
    let browserLang =
      navigator.language.toUpperCase()[0] + navigator.language.toUpperCase()[1];
    super(props);
    this.state = {
      lang: browserLang ? browserLang : "PT",
      languageCode: browserLang ? navigator.language: "pt-PT"
    };


    //super(props);

    //const country = getCountry();
    const country=this.currentLang();
    console.log(this.lang);
    console.log(this.lang);
    console.log("country");
    console.log(country);

    //let lang, languageCode, video;
    /*let registerLink = "https://agromap.agroinsider360.com/register/";

    switch (country) {
      case "portugal":
        lang = PT;
        languageCode = "pt-PT";
        video = "https://www.youtube.com/embed/VDEUKpgZtX0";
        registerLink += "358";
        break;

      case "elsalvador":
        video = "https://www.youtube.com/embed/riJL3co6CzY";
        lang = SV;
        languageCode = "es-SV";
        registerLink += "359";
        break;

      case "espanha":
        video = "https://www.youtube.com/embed/FY56KIEJxnw";
        lang = ES;
        languageCode = "es-ES";
        registerLink += "360";
        break;

      case "english":
        lang = EN;
        languageCode = "en-US";
        video = "https://www.youtube.com/embed/VDEUKpgZtX0";
        registerLink += "361";
        break;
    }*/

    /*this.state = {
      lang,
      languageCode,
      country,
      video
      //registerLink
    };*/

  }
  currentLang = lang => {
    console.log("lang");
    console.log(lang);
    switch (lang) {
      case "PT":
        this.setState({ lang: PT, languageCode: "pt-PT" });
        return PT;
      case "EN":
        this.setState({ lang: EN, languageCode: "en-US" });
        return EN;
      case "ES":
        this.setState({ lang: ES, languageCode: "es-ES" });
        return ES;
      default:
        this.setState({ lang: PT, languageCode: "pt-PT" });
        return PT;
    }
  };
  render() {
    console.log("sssssssssssssssssss");
    console.log(this.state);
    console.log("----------------");
    return (
      <IntlProvider definition={this.state.lang}>
        <div id="App">
          {/* <NavBar langChanged={this.currentLang} /> */}
          {/* <FullVidBlock /> */}
          <NavBar langChanged={this.currentLang}/>

          <Welcome />

          <MainServices />

          <WhatWeOffer id="services" />
          <Video id="howto" video={this.state.video} />
          {/* <WorldView /> */}
          <Contact id="contactus" lang={this.state.languageCode} />
          <Footer />
          <ProjectsModal />
        </div>
      </IntlProvider>
    );
  }
}

export default App;
